import { FC } from 'react';
import { Col, Tab } from 'react-bootstrap';
import { Veg } from 'src/assets/images/Svgs/svg';
import Loader from 'src/components/Loader/Loader';
import { CREATE_YOUR_OWN_ITEM } from 'src/constants';
import ItemGrid from 'src/Features/Menu/ItemGrid/ItemGrid';
import styles from 'src/Features/Menu/menu.module.scss';
import { checkIsItemActive } from 'src/helper/customizedItem/customizedItem.helper';
import { getFilteredItems } from 'src/helper/helperMethods';
import { ItemDetails } from 'src/models/item.model';
import { Menu } from 'src/models/Menu.model';
import { useAppSelector } from 'src/redux/store/store';
import { awsAssetsFetcher } from 'src/utils/awsAssetsFetcher';

interface NavProps {
  menus?: Menu[];
  isSearching?: boolean;
  items?: ItemDetails[];
}
const ManuContainer: FC<NavProps> = (props) => {
  const isOrderTypeSelected = useAppSelector(
    (state) => state.cart.isOrderTypeSelected,
  );
  const savedOrderType = useAppSelector((state) => state.cart.orderType);
  const orderType = isOrderTypeSelected ? savedOrderType : '';
  const { menus, isSearching, items } = props;

  return (
    <>
      {menus.map((data, i) => {
        const filteredItems = isSearching
          ? items
          : getFilteredItems(data.items, []);

        return (
          <Tab.Pane key={i} eventKey={data.name}>
            <h2 className="f-s30 font-Cls fw-normal clr-dark-gray py-3 f-sm-s22">
              {isSearching ? 'Search Results' : data.name}
            </h2>
            <div className="row">
              {filteredItems.length > 0 ? (
                filteredItems.map((item) => {
                  return (
                    <>
                      <Col
                        xl="4"
                        md="6"
                        lg="6"
                        sm="12"
                        className="mb-4"
                        key={item.id}
                      >
                        <ItemGrid
                          favIcon={`${styles.fav_icon_fill}`}
                          itemTitle={item.name}
                          itemImage={awsAssetsFetcher(
                            `Catering/Items/${item?.id}/item-${item?.id}`,
                            'jpeg',
                          )}
                          itemDescription={item.description}
                          symbolIcon={<Veg />}
                          selectButton={
                            !checkIsItemActive(item, orderType)
                              ? 'Unavailable'
                              : 'select'
                          }
                          errorButton={!item.is_active}
                          item={item}
                          disableItem={!checkIsItemActive(item, orderType)}
                          disabledParentClick={false}
                        />
                      </Col>
                    </>
                  );
                })
              ) : (
                <div className="text-center mt-4">
                  <h1 className="mb-4">Items not Found</h1>
                  <p>
                    {' '}
                    Sorry! We couldn’t find what you were looking for. Might we
                    suggest some Cafe Zupas fan favorites...
                  </p>
                </div>
              )}
            </div>
          </Tab.Pane>
        );
      })}
    </>
  );
};

export default ManuContainer;
